export default __webpack_public_path__ + "static/media/Comp 2_00026.c7dae2a6.png";